module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kp-modular-row clearfix"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('edit.sidebar.visibility'))), _c('span', {
    attrs: {
      "klickart-info-tutorial": "edit-visibility"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "kp-modular-check pull-right kp-modular-check-with-icon"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.getValue()
    },
    on: {
      "change": function($event) {
        return _vm.onChange($event)
      }
    }
  }), _vm._v(" "), _c('span'), _vm._v(" "), _c('i', {
    staticClass: "fa fa-eye"
  })])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-07b8bd95!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/modifiers/editors/Display.vue
 ** module id = 753
 ** module chunks = 1
 **/